import { render, staticRenderFns } from "./settlement-bill-detail.vue?vue&type=template&id=223898e3&"
import script from "./settlement-bill-detail.vue?vue&type=script&lang=js&"
export * from "./settlement-bill-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports